'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = require('react-transition-group');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _wrappers = require('../wrappers');

var _ = require('../../');

var _Dialog = require('./Dialog.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dialog window for dispaying alerts, messages, confirms, or anything else.
 */
var Dialog = exports.Dialog = function Dialog(_ref) {
  var cancelText = _ref.cancelText,
      children = _ref.children,
      className = _ref.className,
      confirmText = _ref.confirmText,
      content = _ref.content,
      open = _ref.open,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      onOverlayClick = _ref.onOverlayClick,
      timeout = _ref.timeout,
      title = _ref.title;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      _reactTransitionGroup.TransitionGroup,
      null,
      open && _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        {
          timeout: timeout,
          classNames: 'fade-slide'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'overlay',
            key: _shortid2.default.generate(),
            onClick: onOverlayClick
          },
          _react2.default.createElement(
            'div',
            { className: 'dialog', onClick: function onClick(e) {
                return e.stopPropagation();
              } },
            title && _react2.default.createElement(
              'div',
              { className: 'title' },
              title
            ),
            content && _react2.default.createElement(
              'div',
              { className: 'content' },
              content
            ),
            children && _react2.default.createElement(
              'div',
              { className: 'main' },
              children
            ),
            (onCancel || onConfirm) && _react2.default.createElement(
              'div',
              { className: 'actions' },
              onCancel && _react2.default.createElement(
                _.SecondaryButton,
                {
                  className: 'cancel',
                  onClick: onCancel
                },
                cancelText
              ),
              onConfirm && _react2.default.createElement(
                _.PrimaryButton,
                {
                  className: 'confirm',
                  onClick: onConfirm
                },
                confirmText
              )
            )
          )
        )
      )
    )
  );
};

Dialog.propTypes = {
  /**
   * Text for cancel button
   */
  cancelText: _propTypes2.default.string,
  /**
   * Child component(s) to render within the Dialog box
   */
  children: _propTypes2.default.node,
  /**
   * Needed for glamorous styles
   * @ignore
   */
  className: _propTypes2.default.string.isRequired,
  /**
  * Text for confirm button
  */
  confirmText: _propTypes2.default.string,
  /**
   * Text content to display within the Dialog
   */
  content: _propTypes2.default.string,
  /**
  * Cancel button handler. Cancel button will not display if not set.
  */
  onCancel: _propTypes2.default.func,
  /**
  * Confirm button handler. Confirm button will not display if not set.
  */
  onConfirm: _propTypes2.default.func,
  /**
  * Attach function to escape key while mounted.
  * Maybe to CLOSE the Dialog? Perhaps?
  */
  onEscKeyDown: _propTypes2.default.func, // eslint-disable-line
  /**
   * Function to call when clicking outside the Dialog box.
   * Often you will want a function to close the Dialog.
   */
  onOverlayClick: _propTypes2.default.func,
  /**
   * Whether or not the Dialog is open
   */
  open: _propTypes2.default.bool,
  /**
   * Dialog transition timeout. Either integer or object.
   *
   * `{ enter: 300, exit: 100 }`
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  })]),
  /**
   * Dialog title text
   */
  title: _propTypes2.default.string
};
Dialog.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  open: false,
  timeout: 150
};

exports.default = (0, _wrappers.escapable)((0, _glamorous2.default)(Dialog)(_Dialog.defaultStyle, _Dialog.mapTransitionsToStyle, _Dialog.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Dialog/Dialog.js
// module id = 111
// module chunks = 0